<!-- Pug Template -->
<template lang="pug">
.AppStats
	app-stat-block(
		:series="rate30series"
	)
	app-stat-block(
		:series="rate15series"
	)
</template>

<!-- Script -->
<script>
import AppStatBlock from './AppStatBlock.vue';
export default {
	components: {
		AppStatBlock
	},
	props: {
		chart: {
			type: Object
		}
	},
	computed : {
		rate30series(){
			
			return this.chart.series.find( s => {
				return s.name == '30Y FRM'
			} )
		},
		rate15series(){
			return this.chart.series.find( s => {
				return s.name == '15Y FRM'
			} )
		}
	},
	created(){
		
	}
};
</script>

<!-- SCSS Style -->
<style lang="scss">
.AppStats {
	display: grid;
	grid-template-columns: repeat( auto-fit, minmax(280px, 1fr));
	column-gap: 50px;
	> div {
		margin-bottom: 50px;
	}
	> div:first-child {
		position: relative;
		&::before {
			position: absolute;
			content: ' ';
			display: block;
			width: 1px;
			background: #e2e2e2;
			height: 100%;
			top: 0;
			left: 100%;
			margin-left: 25px;
		}
	}
}
</style>